import React from 'react';
import { useSelector } from 'react-redux';

import { MachineSetup } from 'components/MachineSetup';
import { JOB_STATUSES } from 'lib/constants';
import { getJobStatus } from 'lib/selectors/getJobStatus';
import { getHasOpenActivitySetInSetup } from 'lib/selectors/getHasOpenActivitySetInSetup';

import { getIsUnknownJob } from 'lib/selectors/getIsUnknownJob';
import { getIsWaitingForWork } from 'lib/selectors/getIsWaitingForWork';
import { getIsWaitingForOperator } from 'lib/selectors/getIsWaitingForOperator';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';
import { getCurrentWorkOrderOp } from 'lib/selectors/getCurrentWorkOrderOp';
import WaitingForWork from 'pages/Machine/MachineMainWrapper/WaitingForWork';
import UnknownJob from 'pages/Machine/MachineMainWrapper/UnknownJob';
import WaitingForOperator from 'pages/Machine/MachineMainWrapper/WaitingForOperator';
import { PartCount } from './PartCount';

const MachineStatus = () => {
  const jobStatus = useSelector(getJobStatus);
  const hasOpenActivitySetInSetup = useSelector(getHasOpenActivitySetInSetup);
  const isSetup = hasOpenActivitySetInSetup || jobStatus === JOB_STATUSES.SETUP;

  const isWaitingForWork = useSelector(getIsWaitingForWork);
  const isUnknownJob = useSelector(getIsUnknownJob);
  const isWaitingForOperator = useSelector(getIsWaitingForOperator);
  const isApmERPJobFlow = useSelector(getIsApmERPJobFlow);
  const currentWorkOrderOp = useSelector(getCurrentWorkOrderOp);

  const showOperationalStatus = !(isApmERPJobFlow && currentWorkOrderOp);

  if (showOperationalStatus) {
    if (isWaitingForWork) {
      return <WaitingForWork />;
    }

    if (isWaitingForOperator) {
      return <WaitingForOperator />;
    }

    if (isUnknownJob) {
      return <UnknownJob />;
    }
  }

  if (isSetup) {
    return <MachineSetup />;
  }

  return <PartCount />;
};

export { MachineStatus };
